import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import {
  IApiResultResponse, IBaseResponse, IFinishes,
  IFilterItemRequest,
  IGetItemSuggestionsBody, ItemSearchCritera, ItemSuggestion,
  MasterData, SearchItemResultPageResource, BaseResponse, IItemCatalog, DiscItem,
  DiscountStoreCheckoutModel, DiscountStoreItemImportModel,
  IDiscountStoreOrderHeader,
  IDiscountStoreOrderDetails,
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';


@Injectable({
  providedIn: 'root'
})
export class DiscountStoreService {

  public results: any[];
  public path: string;
  public loading: boolean;
  constructor(private httpClient: HttpClient) {
    this.results = [];
    this.path = ``;
    this.loading = false;
  }
  //#region Deal Flag
  public getDealFlag() {
    const endPoint = '/DiscountStore/FetchDealFlag';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }

  public handleDealSwitchToggle(flag: boolean) {
    const endPoint = '/DiscountStore/UpdateDealFlag';
    return ApiService.genericObservablePost(this.httpClient, endPoint, { data: flag });
  }
  //#endregion
  //#region Admin Section


  public getAllItems() {
    const endPoint = '/DiscountStore/GetAllItems';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  public saveItem(item: DiscItem) {
    const endPoint = '/DiscountStore/SaveItem';
    const body = item;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body);
  }

  public getAllLocationsForOrderClearance() {
    const endPoint = '/DiscountStore/GetAllLocationsForOrderClearance';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  
  public deleteItem(itemId: string) {
    const endPoint = '/DiscountStore/DeleteItem';
    const body = { itemId: itemId };
    return ApiService.genericObservablePost(this.httpClient, endPoint, body);
  }
  public updateDealFlag(flag: boolean) {
    const endPoint = '/DiscountStore/UpdateDealFlag';
    const body = { data: flag };
    return ApiService.genericObservablePost(this.httpClient, endPoint, body);
  }
  //#endregion
  //#region User Section
  public getItemsForOrder() {
    const endPoint = '/DiscountStore/GetItemsForOrder';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }

  public placeOrder(d) {
    const endPoint = '/DiscountStore/PlaceOrder';
    const body = d;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body);
  }
  //#endregion
  //#region Other common functions
  public getLocationList() {
    const endPoint = '/DiscountStore/GetLocationList';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  public fetchDealFlag() {
    const endPoint = '/DiscountStore/FetchDealFlag';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  //#endregion
  //#region Order Processing
  public getOpenOrders() {
    const endPoint = '/DiscountStore/GetOpenOrders';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }

  public getCompletedOrders() {
    const endPoint = '/DiscountStore/GetCompletedOrders';
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }

  public getOrderDetails(orderNum) {
    const endPoint = '/DiscountStore/GetOrderDetails';
    const data = { orderNumber: orderNum };
    return ApiService.genericObservablePost(this.httpClient, endPoint, data);
  }

  public completeOrder(d) {
    const endPoint = '/DiscountStore/CompleteOrder';
    const body = d;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body);
  }
  //#endregion

  //#region Item Management
  public bulkUploadItems(d: DiscountStoreItemImportModel) {
    const endPoint = '/DiscountStore/ImportItems';
    return ApiService.genericObservablePost(this.httpClient, endPoint, d);
  }
  public validateItemsForImport(data: DiscountStoreItemImportModel) {
    const endPoint = '/DiscountStore/ValidateItemsForImport';
    return ApiService.genericObservablePost(this.httpClient, endPoint, data);
  }
  //#endregion

  //#region Discount store section
  private orderDiscountDetailsGridData: IDiscountStoreOrderDetails[];
  private singleDiscountOrderHeaderGridData: IDiscountStoreOrderHeader;
  public setSingleDiscountOrderHeaderGridData(data: IDiscountStoreOrderHeader) {
    this.singleDiscountOrderHeaderGridData = data;
  }  
  public getSingleDiscountOrderHeaderGridData() {
    return this.singleDiscountOrderHeaderGridData;
  }
  public setDiscountOrderDetailsGridData(data: IDiscountStoreOrderDetails[]) {
    this.orderDiscountDetailsGridData = data;
  }
  //#endregion

  // #region Price History
  public getPriceHistoryForItem(item: DiscItem) {
    const endpoint = '/DiscountStore/GetPriceHistoryForItem';
    return ApiService.genericObservablePost(this.httpClient, endpoint, item);
  }
  // #endregion
}
